import React, { useEffect, useState } from 'react';

import { 
  CharacterSheetInterface,
} from "@dndModels";
import CommonUtilities from "@utilities/common_utilities";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import FlexBox from '@components/layout/FlexBox';
import SelectStringBox from '@components/input/selects/SelectStringBox';
import { ONES_0_to_50 } from '@dndModels/Constants';

interface Props {
  char: CharacterSheetInterface;
  disabled?: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterACCustomizations({ 
  char,
  disabled = false,
}: Props) {
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="row" className="padded">
      <FlexBox xs_expand={0} className="centered" style={{ width: "33%" }} direction="column">
        <FlexBox xs_expand={0} className="header">
          Override Armor Class: 
        </FlexBox>
        <FlexBox xs_expand={0} className="small_label gray">
          Currently { char.armor_class }
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <SelectStringBox 
          name=""
          value={ char.customizations.overrides.ac === undefined ? "Don't Override" : `${char.customizations.overrides.ac}` } 
          options={["Don't Override",...ONES_0_to_50]}
          disabled={ disabled }
          onChange={ async (changed: string) => {
            if (changed === "Don't Override") {
              delete char.customizations.overrides.ac;
            } else {
              char.customizations.overrides.ac = +changed;
            }
            setReloading(true);
            char.changed();
            char.subscription_holder.recalculate();
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
